import { CurrencyEnum } from "../models/currency";

export const showCurrency = (currency: CurrencyEnum) => {
  if (currency === CurrencyEnum.NGN) {
    return "NGN";
  } else if (currency === CurrencyEnum.ZAR) {
    return "ZAR";
  } else {
    return "GH₵";
  }
};

export function currencyFormat(num: number | undefined | null) {
  // Return "0.00" if value is undefined, null or NaN
  if (num === undefined || num === null || isNaN(num)) {
    return "0.00";
  }
  return num.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
}
